/* <kg-scroll-fade>: Wrapper um einen Scrollbereich (erstes Kind). Setzt data-fade-top, data-fade-bottom, data-fade-start und data-fade-end, wenn in der Richtung noch Inhalt folgt. Mit data-drag lässt sich der Bereich mit der Maus ziehen. */

class KgScrollFade extends HTMLElement {
  connectedCallback() {
    this.scroller = this.firstElementChild;
    if (!this.scroller) return;
    this.update = this.update.bind(this);
    this.scroller.addEventListener('scroll', this.update, { passive: true });
    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this.scroller);
    [...this.scroller.children].forEach((child) => this.resizeObserver.observe(child));
    this.mutationObserver = new MutationObserver(this.update);
    this.mutationObserver.observe(this.scroller, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class'] });
    if (this.hasAttribute('data-drag')) this.setupDrag();
    this.update();
  }

  disconnectedCallback() {
    this.scroller?.removeEventListener('scroll', this.update);
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
  }

  update() {
    /*
      Einmal je Bild statt bei jedem Scrollereignis: Liest jedes Ereignis die Masse des
      Scrollbereichs und schreibt Attribute, ruckelt das Wischen, weil der Browser dazwischen
      jedes Mal neu rechnen muss.
    */
    if (this.wartet) return;
    this.wartet = true;
    window.requestAnimationFrame(() => {
      this.wartet = false;
      if (!this.scroller) return;
      const { scrollTop, scrollHeight, clientHeight, scrollLeft, scrollWidth, clientWidth } = this.scroller;
      this.setzen('data-fade-top', scrollTop > 2);
      this.setzen('data-fade-bottom', scrollTop + clientHeight < scrollHeight - 2);
      this.setzen('data-fade-start', scrollLeft > 2);
      this.setzen('data-fade-end', scrollLeft + clientWidth < scrollWidth - 2);
    });
  }

  /* Nur schreiben, wenn sich der Zustand wirklich aendert */
  setzen(name, an) {
    if (this.hasAttribute(name) === an) return;
    this.toggleAttribute(name, an);
  }

  setupDrag() {
    const scroller = this.scroller;
    let dragging = false;
    let moved = false;
    let startX = 0;
    let startScroll = 0;

    scroller.addEventListener('dragstart', (event) => {
      if (scroller.scrollWidth > scroller.clientWidth) event.preventDefault();
    });

    scroller.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (scroller.scrollWidth <= scroller.clientWidth) return;
      dragging = true;
      moved = false;
      startX = event.clientX;
      startScroll = scroller.scrollLeft;
    });

    scroller.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const delta = event.clientX - startX;
      if (!moved && Math.abs(delta) > 4) {
        /* Erst ab echter Bewegung den Zeiger einfangen, sonst gehen Klicks auf Kinder (Buttons, Links) verloren. */
        moved = true;
        this.classList.add('is-dragging');
        scroller.setPointerCapture(event.pointerId);
      }
      if (moved) scroller.scrollLeft = startScroll - delta;
    });

    const stop = (event) => {
      if (!dragging) return;
      dragging = false;
      this.classList.remove('is-dragging');
      if (scroller.hasPointerCapture(event.pointerId)) scroller.releasePointerCapture(event.pointerId);
    };
    scroller.addEventListener('pointerup', stop);
    scroller.addEventListener('pointercancel', stop);

    scroller.addEventListener(
      'click',
      (event) => {
        if (!moved) return;
        moved = false;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
  }
}

customElements.define('kg-scroll-fade', KgScrollFade);
